import React from "react";
import { Accordion, Button, Card, Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { DesignerElement } from "../../helpers";



interface Props {
  selectedElement?: DesignerElement,
  updateValue?: (el: DesignerElement) => void,
}

export const DesignerAnimations: React.FC<Props> = props => {

  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const removeAnimation = (idx: number) => {
    const el = { ...props.selectedElement };
    el.animations.splice(idx, 1);
    props.updateValue(el);
    setSelectedIndex(-1);
  }

  const addAnimation = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = { ...props.selectedElement };
    if (!el.animations) el.animations = [];
    el.animations.push({ type: "fadeIn", start: 0, end: 0, delay: 0, duration: 0 })
    props.updateValue(el);
    setSelectedIndex(el.animations.length - 1);
  }


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateValue(e.currentTarget.id, e.currentTarget.value)
  }

  const updateValue = (id: string, val: string) => {
    let el: DesignerElement = { ...props.selectedElement };
    let an = el.animations[selectedIndex];
    switch (id) {
      case "anType": an.type = val; break;
      case "delay": an.delay = parseInt(val, 0); break;
      case "start": an.start = parseInt(val, 0); break;
      case "end": an.end = parseInt(val, 0); break;
      case "duration": an.duration = parseInt(val, 0); break;
      case "direction": an.direction = val; break;
    }
    props.updateValue(el);
  }


  const getEditAnimation = () => {
    if (selectedIndex > -1) {
      const an = props.selectedElement.animations[selectedIndex]
      const result: JSX.Element[] = [];
      result.push(<FormGroup as={Row}>
        <FormLabel column sm={4}>Type</FormLabel>
        <Col sm={8}>
          <FormControl as="select" size="sm" id="anType" value={an.type} onChange={handleChange}>
            <option value="blur">Blur</option>
            <option value="fadeIn">Fade In</option>
            <option value="fadeOut">Fade Out</option>
            <option value="growVert">Grow Vertical</option>
            <option value="growHor">Grow Horizontal</option>
            <option value="slideIn">Slide In</option>
            <option value="slideOut">Slide Out</option>
            <option value="zoom">Zoom</option>
          </FormControl>
        </Col>
      </FormGroup>);
      if (an.type === "slideIn" || an.type === "slideOut") result.push(<FormGroup as={Row}>
        <FormLabel column sm={4}>Direction</FormLabel>
        <Col sm={8}>
          <FormControl as="select" size="sm" id="direction" value={an.direction} onChange={handleChange}>
            <option value="left">Left</option>
            <option value="right">Right</option>
            <option value="top">Top</option>
            <option value="bottom">Bottom</option>
          </FormControl>
        </Col>
      </FormGroup>);
      if (an.type === "blur" || an.type === "fadeIn" || an.type === "fadeOut" || an.type === "zoom") {
        let startEndDesc = "opacity - 0-100";
        if (an.type === "zoom") startEndDesc = "scale - current size=1";
        if (an.type === "blur") startEndDesc = "pixels - 0=no blur";

        result.push(<FormGroup as={Row}>
          <FormLabel column sm={4}>Start <span className="description">({startEndDesc})</span></FormLabel>
          <Col sm={8}><FormControl id="start" size="sm" value={an.start} onChange={handleChange} /></Col>
        </FormGroup>);
        result.push(<FormGroup as={Row}>
          <FormLabel column sm={4}>End <span className="description">({startEndDesc})</span></FormLabel>
          <Col sm={8}><FormControl id="end" size="sm" value={an.end} onChange={handleChange} /></Col>
        </FormGroup>);
      }
      result.push(<FormGroup as={Row}>
        <FormLabel column sm={4}>Delay <span className="description">(ms)</span></FormLabel>
        <Col sm={8}><FormControl id="delay" size="sm" value={an.delay} onChange={handleChange} /></Col>
      </FormGroup>);
      result.push(<FormGroup as={Row}>
        <FormLabel column sm={4}>Duration <span className="description">(ms)</span></FormLabel>
        <Col sm={8}><FormControl id="duration" size="sm" value={an.duration} onChange={handleChange} /></Col>
      </FormGroup>);

      return (<>
        <h4>Edit Animation</h4>
        {result}
        <Button size="sm" variant="primary" block={true} onClick={(e) => { e.preventDefault(); setSelectedIndex(-1) }}>Save Animation</Button >
      </>);
    }
  }

  const getTable = () => {
    if (props.selectedElement.animations?.length > 0) {
      const rows: JSX.Element[] = [];
      let i = 0;
      props.selectedElement.animations.forEach(a => {
        const idx = i;
        rows.push(<tr><td>
          <a href="about:blank" className="float-right text-danger" onClick={(e) => { e.preventDefault(); removeAnimation(idx) }} ><i className="fas fa-trash-alt"></i></a>
          <a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedIndex(idx) }} >{a.type}</a>
        </td></tr>);
        i++
      })
      return (<>
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Animation</th>
            </tr>
            {rows}
          </thead>
        </table>
        {getEditAnimation()}
      </>);
    } else {
      return <p>This element is not animated</p>
    }

  }


  return (
    <Card>
      <Card.Header>
        <Accordion.Toggle eventKey="animations">Animations</Accordion.Toggle>
      </Card.Header>
      <Accordion.Collapse eventKey="animations">
        <Card.Body>
          <Button size="sm" variant="success" block={true} style={{ marginBottom: 10 }} onClick={addAnimation}>New Animation</Button>
          {getTable()}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );

}